module.exports = __webpack_public_path__ + "static/img/Ellipse 102.943ddab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse 102.png
// module id = 2F5n
// module chunks = 1